<template>
  <div>
    <b-breadcrumb :items="breadcrumb"/>
    <h1>Search Applications by Status</h1>
    <div class="row">
      <div class="col-md-9">
        <b-form inline>
          <div class="filter-group">
            <label>Completed Filter</label>
            <b-form-checkbox id="enableCompletedFilter" v-model="enableCompletedFilter">
              Enabled
            </b-form-checkbox>
            <b-form-select :disabled="enabledCompletedFilter" id="completedFilter" v-model="completed" :options="bool"/>
          </div>
          <div class="filter-group">
            <label>Team Leader Filter</label>
            <b-form-checkbox id="enableTeamLeaderFilter" v-model="enableTeamLeaderFilter">
              Enabled
            </b-form-checkbox>
            <b-form-select :disabled="enabledTeamLeaderFilter" id="teamLeaderFilter" v-model="teamLeader" :options="bool"/>
          </div>
          <div class="filter-group">
            <label>Financial Aid Filter</label>
            <b-form-checkbox id="enableFinancialAidFilter" v-model="enableFinancialAidFilter">
              Enabled
            </b-form-checkbox>
            <b-form-select :disabled="enabledFinancialAidFilter" id="financialAidFilter" v-model="financialAid" :options="bool"/>
          </div>
          <b-button @click="filterApps" :disabled="isFiltering" size="sm" variant="primary">Filter</b-button>
        </b-form>
      </div>
    </div>
    <!-- Modal Component -->
    <b-modal ref="exportModal" id="export-modal" title="Export to CSV" ok-title="Cancel" ok-variant="danger" ok-only @ok="cancelDownload">
      <b-progress :max="exportData.total" show-progress animated>
        <b-progress-bar :value="exportData.progress">
          <strong>{{ exportData.progress }} / {{ exportData.total }}</strong>
        </b-progress-bar>
      </b-progress>
      <p class="my-4">Downloading data for CSV...</p>
    </b-modal>

    <b-table striped hover :fields="fields" :items="filteredApps">
      <template slot="completed" slot-scope="data">
        <i v-if="data.item.completed" class="icon ion-checkmark"/>
        <i v-else class="icon ion-close"/>
      </template>
      <template slot="teamLeader" slot-scope="data">
        <i v-if="data.item.teamLeader" class="icon ion-checkmark"/>
        <i v-else class="icon ion-close"/>
      </template>
      <template slot="financialAid" slot-scope="data">
        <i v-if="data.item.financialAid" class="icon ion-checkmark"/>
        <i v-else class="icon ion-close"/>
      </template>
      <template slot="view" slot-scope="data">
        <router-link :to="{ name: 'ViewApp', params: { username: data.item.username } }">
          View App
        </router-link>
      </template>
    </b-table>
    <div class="row">
      <div class="col-md-9">
        <b-pagination @input="changePage" size="md" :total-rows="appPagination.total" v-model="page" :per-page="appPagination.limit"/>
      </div>
      <div class="col-md-3">
        <b-button @click="exportApps" class="export" size="sm" variant="secondary">Export to CSV</b-button>
        <b-form-checkbox v-model="withData">With App Data</b-form-checkbox>
        <b-form-checkbox v-model="withScores">With Essay Score Averages</b-form-checkbox>
        <div v-if="isFiltering" class="loader">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'SearchAppStatus',
    data () {
      return {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'Home' }
          },
          {
            text: 'Search Apps by Status',
            to: { name: 'SearchAppStatus' }
          }
        ],
        fields: [
          'firstName',
          'lastName',
          'email',
          'svId',
          'completed',
          'teamLeader',
          'financialAid',
          'view'
        ],
        bool: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ],
        page: 1,
        enableCompletedFilter: false,
        completed: true,
        enableTeamLeaderFilter: false,
        teamLeader: true,
        enableFinancialAidFilter: false,
        financialAid: true,
        isFiltering: false,
        withData: false,
        withScores: false
      }
    },
    computed: {
      enabledCompletedFilter () {
        return !this.enableCompletedFilter
      },
      enabledTeamLeaderFilter () {
        return !this.enableTeamLeaderFilter
      },
      enabledFinancialAidFilter () {
        return !this.enableFinancialAidFilter
      },
      ...mapState('admin', ['filteredApps', 'appPagination', 'exportData'])
    },
    methods: {
      filterApps (e) {
        this.isFiltering = true
        this.$store.dispatch('admin/filterApps', {
          filterCompleted: this.enableCompletedFilter,
          completed: this.completed,
          filterTeamLeader: this.enableTeamLeaderFilter,
          teamLeader: this.teamLeader,
          filterFinancialAid: this.enableFinancialAidFilter,
          financialAid: this.financialAid,
          page: 1
        }).then(() => {
          this.isFiltering = false
          this.page = this.$store.state.admin.appPagination.page
        }).catch(err => {
          console.log(err)
          this.isFiltering = false
        })
      },
      exportApps (e) {
        this.$refs.exportModal.show()
        this.$store.dispatch('admin/exportApps', {
          filterCompleted: this.enableCompletedFilter,
          completed: this.completed,
          filterTeamLeader: this.enableTeamLeaderFilter,
          teamLeader: this.teamLeader,
          filterFinancialAid: this.enableFinancialAidFilter,
          financialAid: this.financialAid,
          withData: this.withData,
          withScores: this.withScores
        }).then(() => {
          this.$refs.exportModal.hide()
        })
      },
      cancelDownload (e) {
        this.$store.commit('admin/cancelDownload')
      },
      changePage (page) {
        this.$store.dispatch('admin/filterApps', {
          filterCompleted: this.enableCompletedFilter,
          completed: this.completed,
          filterTeamLeader: this.enableTeamLeaderFilter,
          teamLeader: this.teamLeader,
          filterFinancialAid: this.enableFinancialAidFilter,
          financialAid: this.financialAid,
          page: page
        }).then(() => {
          this.page = this.$store.state.admin.appPagination.page
        }).catch(err => {
          console.log(err)
        })
      }
    },
    created: function () {
      if (this.$store.state.admin.filteredApps.length === 0) {
        this.filterApps(null)
      }
    }
  }
</script>

<style lang="scss">
  .filter-group {
    display: inline;
    margin: 0px 15px 15px 15px;
    .custom-checkbox {
      display: inline;
    }
  }
  .ion-checkmark {
    color: #20d200;
  }
  .ion-close {
    color: #ff0000;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/SearchAppStatus.vue